const positionTeamInviteIncludesCompany = () => true

module.exports = {
  positionTeamInviteIncludesCompany,
}
